<template>
  <div class="issue-epss-table-cell column">
    <epss-score v-if='hasEPSS' class='issue-epss-table-cell__data' :value='getEPSS'/>
  </div>
</template>

<script>
import EpssScore from '@/components/common/EpssScore.vue';
import actionToTakeTable from '@/mixins/actionToTakeTable';

export default {
  name: 'IssueEPSSTableCell',
  mixins: [actionToTakeTable],
  components: { EpssScore },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasEPSS() {
      return this.getEPSS !== '';
    },

    getEPSS() {
      // First check for epss in item.metaData.epss
      let epss = this.item?.metaData?.epss || 0;

      // If the first position is not available (epss is 0), check the alternative position
      if (epss === 0) {
        epss = this.item?.metaData?.findingsData?.epss || 0;
      }

      // Calculate and round if epss is found, else return an empty string
      epss = Math.round(((epss * 100) + Number.EPSILON) * 100) / 100;

      return epss === 0 ? '' : epss;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issue-epss-table-cell {
  align-items: center;
  display: flex;
  width: rem(53);
  justify-content: center;
}
</style>
